import React from 'react';
import {
  DashedLink,
  LinkIcon,
  DeleteLink,
  MarkupMenuIcon,
} from 'components/pspdf/components/markup-menu/style';
import { linkButtonIds } from 'components/pspdf/components/markup-menu';
import { Selection } from 'components/pspdf/components/selection';
import { isClickedOnElementWithId } from 'components/pspdf/components/helpers';

export default function MarkupMenuLinkIcon({
  annotation,
  instance,
  showFinishLinkAction,
  showDeleteLinkAction,
  onStartLinking,
  onFinishLinking,
  onDeleteLink,
}) {
  //instance.contentDocument.addEventListener("click", handleLinkIconClick);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
  function handleLinkIconClick(event) {
    if (isClickedOnElementWithId(event, linkButtonIds.link)) {
      return handleStartLinkButtonClick();
    }

    if (isClickedOnElementWithId(event, linkButtonIds.finish)) {
      return handleFinishLinkButtonClick();
    }

    if (isClickedOnElementWithId(event, linkButtonIds.delete)) {
      return handleDeleteLinkButtonClick();
    }
  }

  async function handleStartLinkButtonClick() {
    const selection = new Selection(annotation, instance);

    await selection.saveAnnotation({ isLink: true });

    const instantJSON = await instance.exportInstantJSON();

    onStartLinking &&
      onStartLinking(selection.getCustomData(), { instantJSON });
  }

  async function handleFinishLinkButtonClick() {
    const selection = new Selection(annotation, instance);

    await selection.saveAnnotation({ isLink: true });

    if (onFinishLinking) {
      await onFinishLinking(selection.getCustomData());
      // Update annotation to include the global link
      await selection.saveAnnotation({ updatedAt: new Date().toISOString() });
    }
  }

  async function handleDeleteLinkButtonClick() {
    const selection = new Selection(annotation, instance);

    const instantJSON = await instance.exportInstantJSON();

    await selection.saveAnnotation({ isLink: false });

    onDeleteLink && onDeleteLink(selection.getCustomData(), instantJSON);

    if (selection.shouldDeleteAnnotation()) {
      await selection.deleteAnnotation();
    }
  }

  if (showDeleteLinkAction) {
    return (
      <MarkupMenuIcon id={linkButtonIds.delete}>
        <DeleteLink />
      </MarkupMenuIcon>
    );
  }
  if (showFinishLinkAction) {
    return (
      <MarkupMenuIcon id={linkButtonIds.finish}>
        <DashedLink />
      </MarkupMenuIcon>
    );
  } else {
    return (
      <MarkupMenuIcon id={linkButtonIds.link}>
        <LinkIcon />
      </MarkupMenuIcon>
    );
  }
}
